<template>
  <div class="mt-3">
    <div :class="styletable.row">
      <div :class="styletable.col1">Freight Mode</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        {{ getFreightMode(custDetail.service_head) }}
      </div>
    </div>

    <!-- Shipment Type: Selain dari FCL RFQ -->
    <div
      :class="styletable.row"
      v-if="!custDetail.shipment_type.includes('FCL') && typeRequest === 'RFQ'"
    >
      <div :class="styletable.col1">
        {{ getName(custDetail.shipment_type, 'STYPE') }}
      </div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        {{ getShipmentType(custDetail.shipment_type) }}
      </div>
    </div>

    <!-- Vessel: Barge & LCT -->
    <div
      :class="styletable.row"
      v-if="
        custDetail.shipment_type === 'BARGE' ||
          custDetail.shipment_type === 'LCT'
      "
    >
      <div :class="styletable.col1">
        {{ getName(custDetail.shipment_type, 'VTYPE') }}
      </div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">{{ custDetail.service_sub_type }}</div>
    </div>

    <!-- CONTRACT : Total Shipment -->
    <div
      :class="styletable.row"
      v-if="typeRequest === 'Contract' && custDetail.shipment_type !== 'SEALCL'"
    >
      <div :class="styletable.col1">Total Shipment</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">{{ custDetail.totalshipment }}</div>
    </div>

    <!-- CONTRACT : Total Container -->
    <div
      :class="styletable.row"
      v-if="
        typeRequest === 'Contract' && custDetail.shipment_type.includes('FCL')
      "
    >
      <div :class="styletable.col1">Total Container</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">{{ custDetail.total_quantity }}</div>
    </div>

    <!-- FCL & SEABREAKBULK: Total Quantity -->
    <div
      :class="styletable.row"
      v-if="
        getStyleShipmentEntry(
          custDetail.service_head,
          custDetail.shipment_type
        ) === 'PACKING'
      "
    >
      <div :class="styletable.col1">Total Quantity</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2" v-if="typeRequest === 'Contract'">
        {{ custDetail.total_quantity }}
      </div>
      <div :class="styletable.col2" v-else>{{ custDetail.estimatedqty }}</div>
    </div>

    <!-- CONTRACT: Cargo Packaging Type -->
    <div
      :class="styletable.row"
      v-if="typeRequest === 'Contract' && custDetail.service_head === 'AIR'"
    >
      <div :class="styletable.col1">
        Cargo Packaging Type
      </div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">{{ custDetail.satuan }}</div>
    </div>

    <!-- FCL & SEABREAKBULK: Estimate Total Weight -->
    <div
      :class="styletable.row"
      v-if="
        getStyleShipmentEntry(
          custDetail.service_head,
          custDetail.shipment_type
        ) === 'PACKING'
      "
    >
      <div :class="styletable.col1">Estimate Total Weight</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2" v-if="typeRequest === 'RFQ'">
        {{ parseFloat(custDetail.estimatedweight).toLocaleString() }}
        {{ unitTotalWeight }}
      </div>
      <div :class="styletable.col2" v-else>
        {{ parseFloat(custDetail.total_weight).toLocaleString() }}
        {{ unitTotalWeight }}
      </div>
    </div>

    <!-- RFQ: BARGE & LCT Total Weight -->
    <div
      :class="styletable.row"
      v-if="
        typeRequest === 'RFQ' &&
          (custDetail.shipment_type === 'BARGE' ||
            custDetail.shipment_type === 'LCT')
      "
    >
      <div :class="styletable.col1">Total Weight</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        {{ custDetail.estimatedweight | Currency('') }} Kg
      </div>
    </div>

    <!-- AIR & LCL & AIRBREAKBULK: Estimate Weight/Shipment -->
    <div
      :class="styletable.row"
      v-if="
        typeRequest === 'Contract' && custDetail.shipment_type.includes('FCL')
      "
    >
      <div :class="styletable.col1">Estimate Container/Shipment</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        {{ custDetail.estimateddimension | Currency('') }} Container
      </div>
    </div>

    <!-- AIR & LCL & AIRBREAKBULK: Volumetric -->
    <div
      :class="styletable.row"
      v-if="
        getStyleShipmentEntry(
          custDetail.service_head,
          custDetail.shipment_type
        ) === 'PACKING'
      "
    >
      <div :class="styletable.col1">Volumetric</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        {{ custDetail.estimateddimension | Currency('') }} CBM
      </div>
    </div>

    <!-- Packaging: untuk RFQ selain FCL, BARGE, LCT dan LCL Contract -->
    <div
      v-if="
        (typeRequest === 'RFQ' &&
          !custDetail.shipment_type.includes('FCL') &&
          custDetail.shipment_type !== 'BARGE' &&
          custDetail.shipment_type !== 'LCT') ||
          custDetail.shipment_type === 'SEALCL'
      "
    >
      <div
        v-for="(listpacking, idx) in custDetail.shipment_type === 'SEALCL' &&
        typeRequest === 'Contract'
          ? custDetail.packing_list
          : getJsonStringfy(custDetail.packing_list)"
        :key="idx"
      >
        <div
          class="mt-3 mb-1 textbold"
          v-if="
            getStyleShipmentEntry(
              custDetail.service_head,
              custDetail.shipment_type
            ) === 'PACKING'
          "
        >
          Shipment Data <span v-if="typeRequest === 'RFQ'">{{ idx + 1 }}</span>
        </div>
        <div :class="styletable.row">
          <div :class="styletable.col1">
            {{ getName(getShipmentType(custDetail.shipment_type), 'QTY') }}
          </div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{ listpacking.qty }}</div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">
            {{ getName(custDetail.shipment_type, 'WEIGHT') }}
          </div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{ listpacking.weight }} Kg</div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">
            Cargo Packaging Type
          </div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{ listpacking.satuan }}</div>
        </div>

        <div
          :class="styletable.row"
          v-if="
            getStyleShipmentEntry(
              custDetail.service_head,
              custDetail.shipment_type
            ) === 'PACKING'
          "
        >
          <div :class="styletable.col1">Size Per Package</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">
            {{ getDimension(listpacking) }} {{ unitDimension }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-else-if="
        getStyleShipmentEntry(
          custDetail.service_head,
          custDetail.shipment_type
        ) === 'PACKING'
      "
    >
      <div :class="styletable.row">
        <div :class="styletable.col1">Size Per Package</div>
        <div :class="styletable.col3">:</div>
        <div :class="styletable.col2">
          {{ getDimension(getJsonStringfyObj(custDetail.dimension)) }}
          {{ unitDimension }}
        </div>
      </div>
    </div>

    <!-- end: Packaging-->

    <!-- Packaging FCL -->
    <div
      v-if="typeRequest === 'RFQ' && custDetail.shipment_type.includes('FCL')"
      class="mb-2"
    >
      <div
        v-for="(listpacking, idx) in getJsonStringfy(custDetail.packing_list)"
        :key="idx"
      >
        <div class="mt-3 mb-1 textbold">
          Shipment Data <span>{{ idx + 1 }}</span>
        </div>
        <div :class="styletable.row">
          <div :class="styletable.col1">FCL Type</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">
            {{
              listpacking.shipmentType
                ? getShipmentType(listpacking.shipmentType)
                : getShipmentType(custDetail.shipment_type)
            }}
          </div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">Container Type</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">
            {{
              listpacking.containerType
                ? listpacking.containerType
                : custDetail.service_sub_type
            }}
          </div>
        </div>

        <div
          :class="styletable.row"
          v-if="listpacking.containerType === 'Reefer'"
        >
          <div :class="styletable.col1">Temperature</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">
            {{
              listpacking.temperature
                ? listpacking.temperature
                : custDetail.temperature
            }}
            C
          </div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">
            Container Quantity
          </div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{ listpacking.qty }}</div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">
            Cargo Packaging Type
          </div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{ listpacking.satuan }}</div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">
            Weight per Container
          </div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{ listpacking.weight }} Kg</div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">
            Container Option
          </div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">
            {{
              listpacking.containerOption
                ? getContainerOptions(listpacking.containerOption)
                : getContainerOptions(this.custDetail.container_option)
            }}
          </div>
        </div>
      </div>
    </div>
    <!-- end: Packaging FCL -->

    <!-- Packaging VESSEL -->
    <div
      v-if="
        typeRequest === 'RFQ' &&
          getStyleShipmentEntry(
            custDetail.service_head,
            custDetail.shipment_type
          ) === 'VESSELPACKING'
      "
      class="mb-2"
    >
      <div class="mt-3 mb-1 textbold">SHIPMENT DATA</div>
      <div
        v-for="(listpacking, idx) in getJsonStringfy(custDetail.packing_list)"
        :key="idx"
        class="mb-3"
      >
        <div class="mt-2 mb-1 textbold">
          Product Data <span>{{ idx + 1 }}</span>
        </div>
        <div :class="styletable.row">
          <div :class="styletable.col1">Product Type</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{ listpacking.satuan }}</div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">Product Name</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">
            {{ listpacking.productName }}
          </div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">Length</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">
            <span v-if="listpacking.length">{{ listpacking.length }} cm</span>
            <span v-else>-</span>
          </div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">Width/Radius</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">
            <span v-if="listpacking.width">{{ listpacking.width }} cm</span>
            <span v-else>-</span>
          </div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">Height</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">
            <span v-if="listpacking.height">{{ listpacking.height }} cm</span>
            <span v-else>-</span>
          </div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">Weight per Package</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{ listpacking.weight }} Kg</div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">Weight per Product</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">
            {{
              calculateWeightVessel(listpacking.qty, listpacking.weight)
                | currency('', 0, { spaceBetweenAmountAndSymbol: true })
            }}
            Kg
          </div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">Quantity</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{ listpacking.qty }}</div>
        </div>

        <div :class="styletable.row">
          <div :class="styletable.col1">Stuffing Notes</div>
          <div :class="styletable.col3">:</div>
          <div :class="styletable.col2">{{ listpacking.note || '-' }}</div>
        </div>
      </div>
    </div>
    <!-- end: Packaging VESSEL -->

    <!-- FCL: Container Type -->
    <div :class="styletable.row" v-if="typeRequest === 'Contract'">
      <div :class="styletable.col1">Container Type</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">{{ custDetail.service_sub_type }}</div>
    </div>

    <!-- FCL: Container Option -->
    <div :class="styletable.row" v-if="typeRequest === 'Contract'">
      <div :class="styletable.col1">Container Option</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        {{ getContainerOptions(this.custDetail.container_option) }}
      </div>
    </div>

    <!-- SEABREAKBULK: UOM -->
    <div
      :class="styletable.row"
      v-if="custDetail.shipment_type === 'SEABREAKBULK'"
    >
      <div :class="styletable.col1">UOM</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">{{ jsonStringfypackage[0].uom }}</div>
    </div>

    <!-- FCL (Reefer) : Temperature -->
    <div
      :class="styletable.row"
      v-if="
        custDetail.service_sub_type &&
          custDetail.service_sub_type.toLowerCase() === 'reefer' &&
          custDetail.shipment_type.includes('FCL') &&
          typeRequest === 'Contract'
      "
    >
      <div :class="styletable.col1">Temperature</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        {{ custDetail.temp || custDetail.temperature }} C
      </div>
    </div>

    <!-- FCL & SEABREAKBULK: Estimate Total Weight -->
    <div
      :class="styletable.row"
      v-if="
        getStyleShipmentEntry(
          custDetail.service_head,
          custDetail.shipment_type
        ) === 'DEFAULT'
      "
    >
      <div :class="styletable.col1">Estimate Total Weight</div>
      <div :class="styletable.col3">:</div>
      <div :class="styletable.col2">
        {{
          parseFloat(custDetail.estimatedweight).toLocaleString() ||
            parseFloat(custDetail.weight_estimation).toLocaleString()
        }}
        {{ unitTotalWeight }}
      </div>
    </div>
  </div>
</template>
<script>
import mixin from '@/mixin/getters/shipment-details'

export default {
  name: 'AddressDetails',
  props: {
    custDetail: Object,
    typeRequest: String
  },
  mixins: [mixin],
  data() {
    return {
      styletable: {
        row: 'row m-0 mb-1',
        col1: 'col-md-4 pl-0',
        col2: 'col-md pl-1 textcolor textbold',
        col3: 'col-md-0'
      },
      jsonStringfypackage: [],
      unitDimension: '',
      unitTotalWeight: ''
    }
  },
  mounted() {
    if (this.custDetail) {
      this.modifyPackingList()
    }
  },
  methods: {
    getName(shipmenType, type) {
      let currentname = ''
      if (
        shipmenType &&
        (shipmenType.toUpperCase().includes('FCL') ||
          shipmenType.toUpperCase() === 'SEABREAKBULK')
      ) {
        if (type === 'QTY') {
          currentname = 'Container Quantity'
        }
        if (type === 'STYPE') {
          if (shipmenType.toUpperCase() === 'SEABREAKBULK') {
            currentname = 'Shipment Type'
          } else {
            currentname = 'FCL Type'
          }
        }
        if (type === 'WEIGHT') {
          currentname = 'Weight Per Container'
        }
      } else {
        if (type === 'QTY') {
          currentname = 'Packages Quantity'
        }
        if (type === 'STYPE') {
          if (
            shipmenType.toUpperCase() === 'BARGE' ||
            shipmenType.toUpperCase() === 'LCT'
          ) {
            currentname = 'Ocean Type'
          } else {
            currentname = 'Shipment Type'
          }
        }
        if (type === 'WEIGHT') {
          currentname = 'Weight Per Package'
        }
        if (type === 'VTYPE') {
          if (shipmenType.toUpperCase() === 'BARGE') {
            currentname = 'Barge Type'
          } else if (shipmenType.toUpperCase() === 'LCT') {
            currentname = 'LCT Type'
          }
        }
      }
      return currentname
    },

    modifyPackingList() {
      if (
        this.custDetail.shipment_type === 'SEALCL' &&
        this.typeRequest === 'Contract'
      ) {
        const data = this.custDetail
        const packing_list = [
          {
            qty: data.total_quantity,
            weight: data.total_weight,
            satuan: data.satuan
          }
        ]
        this.custDetail.packing_list = packing_list
        this.jsonStringfypackage = packing_list
      }

      if (this.typeRequest === 'RFQ') {
        this.jsonStringfypackage = this.getJsonStringfy(
          this.custDetail.packing_list
        )
      }

      if (this.custDetail.shipment_type === 'SEABREAKBULK') {
        this.unitTotalWeight = 'Tons' // Ton
        this.unitDimension = 'm'
      } else {
        this.unitTotalWeight = 'Kg'
        this.unitDimension = 'cm'
      }
    },

    getStyleShipmentEntry(service, type) {
      let style = 'DEFAULT'
      if (service === 'AIR' || type === 'SEALCL') {
        // multi dimension
        style = 'PACKING'
      } else if (type === 'SEABREAKBULK') {
        // singel dimension
        style = 'DEFAULT'
      } else if (type.includes('FCL')) {
        // fcl multi dimension
        style = 'FCLPACKING'
      } else if (type === 'BARGE' || type === 'LCT') {
        // vessel
        style = 'VESSELPACKING'
      }
      return style
    },

    getContainerOptions(type) {
      if (type === 'SOC') {
        return "Shipper's Own Container (SOC)"
      }
      if (type === 'COC') {
        return "Carrier's Owned Container (COC)"
      }
      return ''
    },

    getDimension(dimension) {
      let size = ''
      if (dimension) {
        size = `${dimension.length ? dimension.length : '0'} x ${
          dimension.width ? dimension.width : '0'
        } x ${dimension.height ? dimension.height : '0'}`
      }
      return size
    },

    getJsonStringfy(arr) {
      const stringify = JSON.parse(arr)
      let result = []
      for (var i = 0; i < stringify.length; i++) {
        result[i] = stringify[i]
      }
      return result
    },

    getJsonStringfyObj(obj) {
      return JSON.parse(obj)
    },

    calculateWeightVessel(qty, weight) {
      return parseFloat(qty) * parseFloat(weight)
    }
  },

  watch: {}
}
</script>



// WEBPACK FOOTER //
// src/components/requestList/detail/tabs-detail/ShipmentType.vue